import styled from 'styled-components'; /* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { navigate } from 'gatsby';
import { PayPalButton } from 'react-paypal-button-v2';
import RotateLoader from 'react-spinners/RotateLoader';
import moment from 'moment';
import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Image from 'components/Image';
import { Radio, Row, Modal } from 'antd';
import {
  CheckoutContainer,
  Overlay,
  SpinnerContainer,
  StyledBackButton,
  BackButtonContainer,
} from 'styles/checkout';
import trainingsApi from 'utils/trainingsApi';
import AlertSvg from 'images/icons/alert.svg';
import AffirmLogo from 'images/icons/Affirm_logo.svg';
import BackSvg from 'images/icons/back.svg';

import StripeBtn from './stripeBtn';
import CheckoutForm from './checkoutForm';

import Affirm from './affirm';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import appConfig from '../utils/appConfig';
const stripePromise = loadStripe(appConfig.publishableKey);

const { Group } = Radio;

const StyledGroup = styled(Group)`
  label:not(:first-child) {
    padding-left: 20px !important;
  }
  label {
    color: #5f5f5f !important;
    font-family: Vollkorn !important;
    font-size: 20px !important;
    font-weight: 600;
    .ant-radio-inner {
      width: 20px !important;
      height: 20px !important;
      border-color: #ff4552 !important;
      border-width: 2px;
      &::after {
        top: 4px !important;
        left: 4px !important;
        background-color: #ff4552 !important;
      }
    }
  }
`;

const StyledModal = styled(Modal)`
  width: 50% !important;
  @media (max-width: 475px) {
    width: 90% !important;
  }
`;

const CheckoutPage = ({ path, trainingId }) => {
  const [clientSecret, setClientSecret] = useState('');
  // const [loading, setLoading] = useState(true);

  const [training, setTraining] = useState({});
  const [isEnrolling, setEnrolling] = useState(false);
  const [people, setPeople] = useState(1);
  const [isEarly, setEarly] = useState(false);
  const [input, setInput] = useState([
    {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      jobtitle: '',
      company: '',
    },
  ]);
  const [formErrors, setFormErrors] = useState([]);
  const [discount, setDiscount] = useState(null);
  const [showDiscountForm, setDiscountForm] = useState(false);
  const [discountInput, setDiscountInput] = useState('');
  const [groupDiscount, setGroupDiscount] = useState(0);
  const [isInvalidCode, setInvalidCode] = useState(false);
  const [couponCodeAlert, setCouponCodeAlert] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [isReadyPayment, setReadyPayment] = useState(false);
  const [isEnrolled, setEnrolled] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seatsLeft, setSeatsLeft] = useState(22);
  const [isPaymentSelected, setPaymentSelected] = useState(false);
  const [isPaymentNotSelected, setPaymentNotSelected] = useState(false);
  const [isPaypalPayment, setPaypalPayment] = useState(false);
  const [isStripePayment, setStripePayment] = useState(false);
  const [isAffirmPayment, setAffirmPayment] = useState(false);
  const [customDiscText, setCustomDiscText] = useState('');
  const [customDiscAmount, setCustomDiscAmount] = useState(0);
  const [visible, setVisible] = useState(false);
  const [affirmVisible, affirmSetVisible] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [
    isDuplicateEnrollmentModalVisible,
    setDuplicateEnrollmentModalVisible,
  ] = useState(false);
  const [
    isCheckingForDuplicateEnrollment,
    setIsCheckingForDuplicateEnrollment,
  ] = useState(false);
  const [duplicateEnrollmentDetails, setDuplicateEnrollmentDetails] = useState(
    {},
  );

  function addPerson() {
    if (isReadyPayment) return;
    setPeople(people + 1);
    setInput([
      ...input,
      {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        jobtitle: '',
        company: '',
      },
    ]);
    setDiscount(null);
  }

  function removePerson() {
    if (isReadyPayment) return;
    if (people > 1) {
      setPeople(people - 1);
      setInput(input.slice(0, input.length - 1));
    }
    setDiscount(null);
  }

  function discountCodeChangeHandler(e) {
    setDiscountInput(e.target.value);
    setInvalidCode(false);
  }

  function discountApplyHandler() {
    const sendData = {
      code: discountInput,
      email: (input.length > 0 && input[0].email) || '',
      trainingId,
      isGroupEnrollment: people > 1,
    };

    axios
      .post(trainingsApi.coupon, sendData)
      .then(({ data }) => {
        setInvalidCode(false);
        setCouponCodeAlert('');

        if (data.isValid) {
          // check whether the coupon code has @ and the amount is less than 200
          if (discountInput && discountInput.indexOf('@') > -1) {
            var codeAmount = discountInput.substring(
              discountInput.indexOf('@') + 1,
            );
            var iCodeAmount = parseInt(codeAmount.trim());
            if (!isNaN(iCodeAmount) && iCodeAmount < 200)
              setCouponCodeAlert(
                'Note: Deposit coupon code applied. Please pay the balance at least 24h prior to training.',
              );
          }

          setDiscount({ amount: data.discountAmount, couponId: data.couponId });
          setDiscountForm(false);
          setDiscountInput('');
        } else setInvalidCode(true);
      })
      .catch((err) => {
        if (err) setInvalidCode(true);
      });
  }

  function inputChangeHandler(e) {
    if (isReadyPayment) return;

    const { name } = e.target;
    const id = Number(name.split('-')[1]) - 1;

    setInput(
      input.map((i, j) =>
        j === id ? { ...i, [name.split('-')[0]]: e.target.value } : i,
      ),
    );
  }

  function handleDuplicateEnrollment() {
    // clear the Invalid code error message
    setDiscountInput('');
    setInvalidCode(false);

    setIsCheckingForDuplicateEnrollment(true);
    const trainees = input.map((i) => ({
      fullName: `${i.firstname} ${i.lastname}`,
      email: i.email.trim(),
      phone: i.phone.trim(),
      title: i.jobtitle.trim(),
      company: i.company.trim(),
    }));

    axios
      .post(trainingsApi.hasAlreadyEnrolled, {
        trainingId: training.trainingId,
        trainees,
      })
      .then(({ data }) => {
        const isAlreadyRegistered = data.some(
          (trainee) => trainee.alreadyRegistered,
        );
        // console.log('isAlreadyRegistered', isAlreadyRegistered);
        if (isAlreadyRegistered) {
          setDuplicateEnrollmentModalVisible(true);
          const alreadyRegisterdUser = data.find(
            (trainee) => trainee.alreadyRegistered,
          );
          // console.log('alreadyRegisterdUser', alreadyRegisterdUser);
          setDuplicateEnrollmentDetails(alreadyRegisterdUser);
        } else {
          // console.log('in paymentSubmitHandler');
          paymentSubmitHandler();
        }
        setIsCheckingForDuplicateEnrollment(false);
      })
      .catch((error) => {
        setIsCheckingForDuplicateEnrollment(false);
      });
  }

  function paymentSubmitHandler() {
    const errors = [];
    const duplicates = [];

    input.forEach((i, index) => {
      if (i.firstname.trim().length === 0 || i.firstname.trim().length > 50) {
        errors.push({
          i: index + 1,
          name: `firstname-${index + 1}`,
          error: 'First Name is mandatory, but not more than 50 characters.',
        });
      }

      if (i.lastname.trim().length === 0 || i.lastname.trim().length > 50) {
        errors.push({
          i: index + 1,
          name: `lastname-${index + 1}`,
          error: 'Last Name is mandatory, but not more than 50 characters.',
        });
      }

      // check for duplicate names
      if (i.firstname.trim().length > 0 && i.lastname.trim().length > 0) {
        let fullname = i.firstname.trim() + ' ' + i.lastname.trim();
        if (duplicates.includes(fullname.toUpperCase())) {
          errors.push({
            i: index + 1,
            name: `lastname-${index + 1}`,
            error: 'Name cannot be duplicate.',
          });
        } else duplicates.push(fullname.toUpperCase());
      }

      if (
        i.email.trim().length === 0 ||
        !(
          typeof document !== 'undefined' &&
          validateEmail(document.getElementById(`email-${index + 1}`).value)
        )
      ) {
        errors.push({
          i: index + 1,
          name: `email-${index + 1}`,
          error: 'A valid email address is mandatory.',
        });
      }

      if (
        i.phone.trim().length < 5 ||
        i.phone.trim().length > 20 ||
        !/^\d+$/.test(i.phone.trim())
      ) {
        errors.push({
          i: index + 1,
          name: `phone-${index + 1}`,
          error:
            'A valid Phone Number is mandatory, no special characters or spaces allowed.',
        });
      }

      if (i.jobtitle.trim().length < 2 || i.jobtitle.trim().length > 100) {
        errors.push({
          i: index + 1,
          name: `jobtitle-${index + 1}`,
          error: 'Job Title is mandatory, between 2 and 100 characters.',
        });
      }

      if (i.company.trim().length < 2 || i.company.trim().length > 100) {
        errors.push({
          i: index + 1,
          name: `company-${index + 1}`,
          error: 'Company is mandatory, between 2 and 100 characters.',
        });
      }
    });

    setFormErrors(errors);

    if (errors.length === 0) setReadyPayment(true);
    // console.log('isAffirmPayment', isAffirmPayment);
    // console.log('isstypepymnt', isStripePayment);
    if (isStripePayment && errors.length === 0) {
      showModal();
    } else if (isAffirmPayment && errors.length === 0) {
      showAffirmModal();
    }

    if (isPaypalPayment && errors.length === 0) {
      setShowPayment(false);
    }

    if (!isPaymentSelected) {
      setPaymentNotSelected(true);
      setReadyPayment(false);
    }

    if (!errors.length) {
      const trainees = input.map((i) => ({
        fullName: `${i.firstname} ${i.lastname}`,
        email: i.email.trim(),
        phone: i.phone.trim(),
        title: i.jobtitle.trim(),
        company: i.company.trim(),
      }));

      // const paymentMethod = isPaypalPayment ? 'Paypal' : 'Stripe';

      let paymentMethod = '';

      if (isPaypalPayment) {
        paymentMethod = 'Paypal';
      } else if (isAffirmPayment) {
        paymentMethod = 'Affirm';
      } else if (isStripePayment) {
        paymentMethod = 'Stripe';
      }
      if (isEnrolling) {
        axios.post(trainingsApi.paymentStarted, {
          trainees,
          training,
          paymentMethod,
        });
      }
      if (!isEnrolling) {
        setLoading(true);
        axios
          .post(trainingsApi.enroll, {
            trainees,
            trainingId: removeSearchParams(trainingId),
          })
          .then(() => {
            setEnrolled(true);
            setSubmitted(true);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      }
    }
  }

  function removeSearchParams(trainingId) {
    const index = trainingId.indexOf('&');
    return index === -1 ? trainingId : trainingId.substring(0, index);
  }

  // email validation function. TODO: Find a home for this in Utils
  function validateEmail(elementValue) {
    var emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    console.log(elementValue + ' - ' + emailPattern.test(elementValue));
    return emailPattern.test(elementValue);
  }

  useEffect(() => {
    axios
      .get(`${trainingsApi.detail}${trainingId}`)
      .then(({ data }) => {
        setTraining(data);
        // console.log("trainingApi data  " + JSON.stringify(data))
        if (data.id) {
          // console.log("trainingApi dataID  " + data.enrollmentClosed)
          setEnrolling(data.enrollmentClosed === 0);
          setEarly(new Date(data.discountEndDate) > new Date());
          setCustomDiscText(data.CustDiscText);
          setCustomDiscAmount(data.CustDiscAmount);
          setPaymentSelected(true);
          setStripePayment(true);
          setShowPayment(true);
        }
        setDataFetched(true);
      })
      .catch(() => {
        if (typeof window !== `undefined`)
          window.location.replace(`/trainings/`);
      });
  }, []);

  useEffect(() => {
    const earlyBirdDiscount = isEarly ? training.discountAmount : training.fee;
    // const groupDisc = people > 1 ? people * training.fee * 0.25 : 0;
    const groupDisc = 0;

    const discountedAmount =
      people > 1 ? training.fee * people - groupDisc : earlyBirdDiscount;

    const seatsLeft = training.batchSize - training.enrollmentCount;
    setSeatsLeft(seatsLeft);

    // setGroupDiscount(groupDisc);
    let totalPriceAmount =
      discount && discount.amount
        ? Number.parseFloat(
            discount.amount.includes('%')
              ? discountedAmount -
                  discountedAmount *
                    Number(discount.amount.replace('%', '')) *
                    0.01
              : discountedAmount - Number(discount.amount),
          )
        : Number.parseFloat(discountedAmount);
    const _totalPrice =
      customDiscAmount && customDiscText
        ? totalPriceAmount - people * customDiscAmount
        : totalPriceAmount;
    // console.log('_totalPrice', _totalPrice);
    // console.log(
    //   'totalpPrice Amount',
    //   totalPriceAmount,
    //   'customdsc',
    //   customDiscAmount,
    // );
    setTotalPrice(_totalPrice);

    if (dataFetched) {
      getClientSecret(_totalPrice);
    }
  }, [
    dataFetched,
    training,
    people,
    discount,
    isEarly,
    customDiscAmount,
    customDiscText,
  ]);

  function updateLoadingStatus(flag) {
    setLoading(flag);
  }

  function updatePaymentMethod(event) {
    // console.log('====tar', event);
    const value = event.target.value;
    // console.log('value ', value);
    if (value === 'paypal') {
      setPaypalPayment(true);
      setStripePayment(false);
      setPaymentSelected(true);
      setPaymentNotSelected(false);
      setAffirmPayment(false);
    } else if (value === 'affirm') {
      setAffirmPayment(true);
      setPaypalPayment(false);
      setStripePayment(false);
      setPaymentSelected(true);
      setPaymentNotSelected(false);
    } else {
      setPaypalPayment(false);
      setStripePayment(true);
      setPaymentSelected(true);
      setPaymentNotSelected(false);
      setAffirmPayment(false);
    }
  }

  function showModal() {
    // const card = elements.getElement(CardNumberElement);
    // if (card) {
    //   card.destroy()
    // }
    setVisible(true);
  }
  function showAffirmModal() {
    // const card = elements.getElement(CardNumberElement);
    // if (card) {
    //   card.destroy()
    // }
    affirmSetVisible(true);
  }

  function handleCancel(e) {
    console.log(e);
    setVisible(false);
    setReadyPayment(false);
    affirmSetVisible(false);
  }

  const getClientSecret = async (amount) => {
    // console.log('in client');
    // setLoading(true);

    const body = {
      amount,
    };
    const { data } = await axios.post(trainingsApi.stripePaymentIntent, body);
    // console.log('data  ', data);
    setClientSecret(data.clientSecret);
    window.localStorage.setItem('payment_intent_id', data.paymentIntentID);
    window.localStorage.setItem(
      'payment_intent_client_secret',
      data.clientSecret,
    );
    // setLoading(false);
  };

  const countryCodeMap = {
    'United States': '$',
    India: '₹',
  };

  return (
    <Layout lightTheme path={path}>
      <Meta
        title={
          isEnrolling
            ? 'Checkout - We appreciate your business'
            : 'Register Now'
        }
        description="Checkout - IT Training - ATC is a Scaled Agile Silver Partner"
      />
      {isSubmitted ? (
        <>
          <div className="container">
            <p className="center" style={{ padding: '100px 0' }}>
              {isEnrolling ? (
                <>
                  Your payment has been processed successfully.
                  <br />
                  Contact Email:&nbsp;
                  <a href="mailto:trainings@american-technology.net">
                    trainings@american-technology.net
                  </a>
                </>
              ) : (
                'Details submitted successfully!'
              )}
            </p>
          </div>
        </>
      ) : (
        <CheckoutContainer>
          {loading ? (
            <Overlay>
              <SpinnerContainer>
                <RotateLoader
                  size={15}
                  color={'#E84848'}
                  loading={loading}
                  margin={2}
                />
              </SpinnerContainer>
            </Overlay>
          ) : null}

          <div className={`half-grey${isEnrolling ? '' : ' full'}`}></div>
          <div className="container">
            <StyledBackButton onClick={() => window.history.back()}>
              <BackButtonContainer>
                <BackSvg style={{ marginRight: '10px' }} />
                Back
              </BackButtonContainer>
            </StyledBackButton>
          </div>
          <section>
            <div className="checkout-area-main">
              <div className="container">
                <div
                  className={`row${
                    isEnrolling ? '' : ' justify-content-center'
                  }`}
                >
                  <div className="col-md-6">
                    <h2 className="checkout-head">
                      {isEnrolling ? 'Checkout' : 'Register Now'}
                    </h2>
                    <div className="checkout-form">
                      <form>
                        <div className="checkout-white-box">
                          <p className="form-head">Event details</p>
                          <div className="form-group">
                            <div className="row">
                              <div className="col-8">
                                <p
                                  style={{
                                    fontSize: 14,
                                    margin: 0,
                                    lineHeight: '22px',
                                  }}
                                >
                                  <strong>How many people are applying?</strong>
                                  <br />
                                  {/* Book two or more to a get 25% discount! */}
                                </p>
                                {seatsLeft > 0 && seatsLeft < 8 && (
                                  <>
                                    <br />
                                    <p style={{ fontSize: 14, margin: 0 }}>
                                      <strong className="pink">
                                        {`Hurry only ${seatsLeft} ${
                                          seatsLeft === 1 ? 'seat' : 'seats'
                                        } left!`}
                                      </strong>
                                    </p>
                                  </>
                                )}
                              </div>
                              <div className="col-4">
                                <div className="number-select-input">
                                  <button
                                    type="button"
                                    className="button-unstyled input-number"
                                    onClick={removePerson}
                                  >
                                    <i className="far fa-minus" />
                                  </button>
                                  <input
                                    type="text"
                                    className="input-num-box"
                                    value={people}
                                  />
                                  <button
                                    type="button"
                                    className="button-unstyled input-number"
                                    onClick={addPerson}
                                  >
                                    <i className="far fa-plus" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {Array.from({ length: people }, (v, k) => k + 1).map(
                          (i) => (
                            <div key={i} className="checkout-white-box">
                              <p className="form-head">{`Basic Details - ${i} of ${people}`}</p>
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`firstname-${i}`}
                                    >
                                      First Name *
                                    </label>
                                    <input
                                      type="text"
                                      id={`firstname-${i}`}
                                      name={`firstname-${i}`}
                                      className="checkout-input"
                                      value={input[i - 1].firstname || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`lastname-${i}`}
                                    >
                                      Last Name *
                                    </label>
                                    <input
                                      type="text"
                                      id={`lastname-${i}`}
                                      name={`lastname-${i}`}
                                      className="checkout-input"
                                      value={input[i - 1].lastname || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`email-${i}`}
                                    >
                                      Email Address *
                                    </label>
                                    <input
                                      type="email"
                                      id={`email-${i}`}
                                      name={`email-${i}`}
                                      className="checkout-input"
                                      value={input[i - 1].email || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`phone-${i}`}
                                    >
                                      Phone No. *
                                    </label>
                                    <input
                                      type="text"
                                      name={`phone-${i}`}
                                      id={`phone-${i}`}
                                      className="checkout-input"
                                      value={input[i - 1].phone || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`jobtitle-${i}`}
                                    >
                                      Job Title *
                                    </label>
                                    <input
                                      type="text"
                                      id={`jobtitle-${i}`}
                                      name={`jobtitle-${i}`}
                                      className="checkout-input"
                                      value={input[i - 1].jobtitle || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group checkout-single">
                                    <label
                                      className="checkout-label"
                                      htmlFor={`company-${i}`}
                                    >
                                      Company / Organisation *
                                    </label>
                                    <input
                                      type="text"
                                      className="checkout-input"
                                      id={`company-${i}`}
                                      name={`company-${i}`}
                                      value={input[i - 1].company || ''}
                                      onChange={inputChangeHandler}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              {formErrors.length > 0 && (
                                <ul className="errors">
                                  {formErrors
                                    .filter((j) => j.i === i)
                                    .map((j) => (
                                      <li key={j.name}>{j.error}</li>
                                    ))}
                                </ul>
                              )}
                            </div>
                          ),
                        )}

                        {!isReadyPayment && (
                          <div className="add-person-area">
                            <button
                              type="button"
                              className="add-person-btn"
                              onClick={addPerson}
                            >
                              <i className="far fa-plus" />
                              <span> Add Person</span>
                            </button>
                          </div>
                        )}

                        {/* {!isEnrolling && (
                          <div className="checkout-btn-area">
                            <button
                              type="button"
                              className="checkout-btn"
                              onClick={paymentSubmitHandler}
                              disabled={isEnrolled}
                            >
                              <span>{isEnrolled ? 'Enrolled!' : 'Done'}</span>
                            </button>
                          </div>
                        )} */}
                      </form>
                    </div>
                  </div>
                  {isEnrolling && (
                    <div className="col-md-5 offset-md-1 col-lg-4 offset-lg-2">
                      <div className="checkout-details">
                        <h3 className="order-sum-head">Order Summary</h3>

                        <div className="checkout-desc-area">
                          {training.id && training.enrollmentClosed === 0 && (
                            <>
                              <table className="table table-borderless table-checkout">
                                <tbody>
                                  <tr>
                                    <td>
                                      {training.certificationName}
                                      <br />
                                      <span>{`x ${people}`}</span>
                                    </td>
                                    <td
                                      className="right bold"
                                      style={{ fontWeight: 'bold' }}
                                    >
                                      {`${
                                        countryCodeMap[training.country]
                                      }${Number.parseFloat(
                                        training.fee * people,
                                      ).toFixed(2)}`}
                                    </td>
                                  </tr>
                                  {isEarly && people === 1 && (
                                    <tr>
                                      <td style={{ color: '#28C397' }}>
                                        Early Bird Discount
                                        {training.discountEndDate && (
                                          <>
                                            {' '}
                                            <br />( Discount ends on{' '}
                                            {moment(
                                              training.discountEndDate,
                                            ).format('ll')}{' '}
                                            ){' '}
                                          </>
                                        )}
                                      </td>
                                      <td
                                        className="right bold"
                                        style={{ color: '#28C397' }}
                                      >
                                        {`- ${
                                          countryCodeMap[training.country]
                                        }${Number.parseFloat(
                                          people *
                                            (training.fee -
                                              training.discountAmount),
                                        ).toFixed(2)}`}
                                      </td>
                                    </tr>
                                  )}
                                  {customDiscText && customDiscAmount && (
                                    <tr>
                                      <td style={{ color: '#28C397' }}>
                                        {customDiscText}
                                      </td>
                                      <td
                                        className="right bold"
                                        style={{ color: '#28C397' }}
                                      >
                                        {`- ${
                                          countryCodeMap[training.country]
                                        }${Number.parseFloat(
                                          people * customDiscAmount,
                                        ).toFixed(2)}`}
                                      </td>
                                    </tr>
                                  )}
                                  {/* {people > 1 && (
                                    <tr>
                                      <td style={{ color: '#28C397' }}>
                                        Group Discount Applied
                                      </td>
                                      <td
                                        className="right bold"
                                        style={{ color: '#28C397' }}
                                      >
                                        {`- $${Number.parseFloat(
                                          groupDiscount,
                                        ).toFixed(2)}`}
                                      </td>
                                    </tr>
                                  )} */}
                                  {discount && discount.amount && (
                                    <tr>
                                      <td style={{ color: '#28C397' }}>
                                        Discount Code Applied
                                      </td>
                                      <td
                                        className="right bold"
                                        style={{ color: '#28C397' }}
                                      >
                                        {discount.amount.includes('%')
                                          ? `-${
                                              countryCodeMap[training.country]
                                            }${discount.amount}`
                                          : `- ${
                                              countryCodeMap[training.country]
                                            }${Number.parseFloat(
                                              discount.amount,
                                            ).toFixed(2)}`}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                              {/* discount */}
                              <div
                                className="discount-area"
                                style={{ paddingTop: 25 }}
                              >
                                {showDiscountForm ? (
                                  <>
                                    <div className="d-flex justify-content-between">
                                      <input
                                        type="text"
                                        name="discountCode"
                                        id="discountCode"
                                        placeholder="Enter discount code"
                                        onChange={discountCodeChangeHandler}
                                        value={discountInput}
                                        disabled={isReadyPayment}
                                      />
                                      <button
                                        type="button"
                                        className="button-usntyled pink-btn white"
                                        onClick={discountApplyHandler}
                                        disabled={isReadyPayment}
                                      >
                                        <span>Apply</span>
                                      </button>
                                    </div>
                                    {isInvalidCode ? (
                                      <p
                                        className="pink bold"
                                        style={{ marginTop: 10 }}
                                      >
                                        Uh oh, this coupon code is invalid!
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <button
                                    type="button"
                                    className="button-unstyled bold show-discount"
                                    onClick={() => setDiscountForm(true)}
                                    disabled={isReadyPayment}
                                  >
                                    {discount && discount.amount
                                      ? 'Use a different discount code'
                                      : 'I have a discount code'}
                                  </button>
                                )}
                                {couponCodeAlert &&
                                couponCodeAlert.length > 0 ? (
                                  <p
                                    className="black small"
                                    style={{ marginTop: 10 }}
                                  >
                                    {couponCodeAlert}
                                  </p>
                                ) : (
                                  ''
                                )}
                              </div>

                              <span className="form-divider"></span>
                              <table className="table table-borderless table-checkout">
                                <tbody>
                                  <tr>
                                    <td className="bold">Total:</td>
                                    <td className="total-td">
                                      {`${
                                        countryCodeMap[training.country]
                                      }${Number.parseFloat(totalPrice).toFixed(
                                        2,
                                      )}`}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              {showPayment &&
                                countryCodeMap[training.country] ==
                                  '$' && (
                                  <div style={{ marginTop: '15%' }}>
                                    <div className="payment-head">
                                      Select Payment Method
                                    </div>

                                    <StyledGroup
                                      style={{
                                        display: 'block',
                                        marginTop: '15px',
                                      }}
                                      defaultValue={'stripe'}
                                    onChange={(e) => {
                                      updatePaymentMethod(e);
                                    }}
                                    ><Row
                                      className="paymentBorder"
                                      style={{ marginTop: '15px' }}
                                    >
                                      <Radio
                                        defaultChecked={true}
                                        className="payment-label"
                                        value={'stripe'}
                                      >
                                        <span className="payment-text">
                                          Pay with Credit Card
                                        </span>
                                      </Radio>
                                    </Row>
                                    
                                    <Row
                                      className="paymentBorder"
                                      style={{
                                        marginTop: '15px',
                                      }}
                                    >
                                      <Radio
                                        className="payment-label"
                                        value={'affirm'}
                                      >
                                        <span className="payment-text">
                                          Pay with
                                          <AffirmLogo
                                            style={{
                                              paddingLeft: '7px',
                                              height: '20px',
                                            }}
                                          />
                                        </span>
                                      </Radio>
                                    </Row>

                                    <Row
                                      className="paymentBorder"
                                      style={{
                                        marginTop: '15px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <Radio
                                        value={'paypal'}
                                        className="payment-label"
                                      >
                                        <span className="payment-text">
                                          Pay with
                                          <img
                                            src="https://safe-training.s3.us-east-2.amazonaws.com/PP_logo_h_100x26.png"
                                            alt="PayPal"
                                            style={{
                                              width: '65.29px',
                                              heigth: '20px',
                                              paddingLeft: '7px',
                                            }}
                                          />
                                          <img src="https://safe-training.s3.us-east-2.amazonaws.com/PP_PL_logo_h_100x26.png" 
                                            alt="PayPal"
                                            style={{
                                              width: '70.29px',
                                              heigth: '20px',
                                              paddingLeft: '7px',
                                            }}
                                          />
                                        </span>
                                      </Radio>
                                    </Row>
                                  </StyledGroup>
                                </div>
                              )}

                              {showPayment && (
                                <div className="checkout-btn-area">
                                  <button
                                    type="button"
                                    className="checkout-btn"
                                    onClick={handleDuplicateEnrollment}
                                  >
                                    <i className="fas fa-lock" />
                                    <span>
                                      {isCheckingForDuplicateEnrollment
                                        ? 'loading...'
                                        : `Proceed to Payment ${
                                            countryCodeMap[training.country]
                                          }${Number.parseFloat(
                                            totalPrice,
                                          ).toFixed(2)}`}
                                    </span>
                                  </button>
                                </div>
                              )}

                              {formErrors.length ? (
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <AlertSvg
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      marginRight: '10px',
                                    }}
                                  />{' '}
                                  Please fill in/check the Basic Details fields
                                </span>
                              ) : null}

                              {isReadyPayment &&
                                isPaymentSelected &&
                                isPaypalPayment && (
                                  <>
                                    <div style={{ paddingTop: 50 }} />

                                    <PayPalButton
                                      className="paypal-button"
                                      amount={totalPrice}
                                      options={{
                                        clientId:
                                          'ATDyb7WRIxJEFwIqBdWhhpToT8QeDnoI0nXUImBW0f_5UTanS4jlb4LTcVQwPDB5K72L1MqJ9lfZ9sTF',
                                        currency: 'USD',
                                        intent: 'capture',
                                      }}
                                      onSuccess={(details, data) => {
                                        const trainees = input.map((i) => ({
                                          fullName: `${i.firstname} ${i.lastname}`,
                                          email: i.email.trim(),
                                          phone: i.phone.trim(),
                                          title: i.jobtitle.trim(),
                                          company: i.company.trim(),
                                        }));

                                        setLoading(true);
                                        axios
                                          .post(trainingsApi.enroll, {
                                            orderId: data.orderID,
                                            trainees,
                                            trainingId: removeSearchParams(
                                              trainingId,
                                            ),
                                            couponId: discount
                                              ? Number(discount.couponId)
                                              : 0,
                                          })
                                          .then(({ data }) => {
                                            setLoading(false);
                                            if (data.operation === 'Success')
                                              navigate('/thanks/');
                                          })
                                          .catch((error) => {
                                            setLoading(false);
                                          });
                                      }}
                                      onError={(error) => {
                                        const trainees = input.map((i) => ({
                                          fullName: `${i.firstname} ${i.lastname}`,
                                          email: i.email.trim(),
                                          phone: i.phone.trim(),
                                          title: i.jobtitle.trim(),
                                          company: i.company.trim(),
                                        }));
                                        const paymentMethod = 'Paypal';
                                        axios.post(trainingsApi.paymentError, {
                                          trainees,
                                          training,
                                          paymentMethod,
                                        });
                                      }}
                                    />
                                    <div
                                      className="discount-area"
                                      style={{ paddingTop: 25 }}
                                    >
                                      <button
                                        type="button"
                                        className="button-unstyled bold show-discount"
                                        onClick={() => {
                                          setReadyPayment(false);
                                          setPaypalPayment(false);
                                          setStripePayment(true);
                                          setShowPayment(true);
                                        }}
                                      >
                                        Select Another Payment Method
                                      </button>
                                    </div>
                                  </>
                                )}

                              {isReadyPayment &&
                                isPaymentSelected &&
                                isStripePayment && (
                                  <>
                                    <div style={{ paddingTop: 50 }} />
                                    <div style={{ width: '100%' }}>
                                      <Elements stripe={stripePromise}>
                                        <StripeBtn
                                          country={training.country}
                                          amount={totalPrice}
                                          input={input}
                                          trainingId={trainingId}
                                          training={training}
                                          discount={discount}
                                          visible={visible}
                                          // onClickFunc={paymentSubmitHandler}
                                          handleCancelFunc={handleCancel}
                                          btnData={`Confirm Payment ${
                                            countryCodeMap[training.country]
                                          }${Number.parseFloat(
                                            totalPrice,
                                          ).toFixed(2)}`}
                                          setLoadingFunc={(flag) => {
                                            updateLoadingStatus(flag);
                                          }}
                                        />
                                      </Elements>
                                    </div>
                                  </>
                                )}

                              {isReadyPayment &&
                                isPaymentSelected &&
                                isAffirmPayment && (
                                  <>
                                    <div style={{ paddingTop: 50 }} />
                                    <div style={{ width: '100%' }}>
                                      <Elements
                                        stripe={stripePromise}
                                        options={{ clientSecret }}
                                      >
                                        <CheckoutForm
                                          isAffirmPayment={isAffirmPayment}
                                          clientSecret={clientSecret}
                                          input={input}
                                          trainingId={trainingId}
                                          training={training}
                                          discount={discount}
                                          visible={affirmVisible}
                                          handleCancelFunc={handleCancel}
                                          amount={totalPrice}
                                        />
                                      </Elements>
                                      {/* <Affirm 
                                      amount={totalPrice}
                                       input={input}
                                       trainingId={trainingId}
                                       training={training}
                                          discount={discount}
                                          visible={affirmVisible}
                                          // onClickFunc={paymentSubmitHandler}
                                          handleCancelFunc={handleCancel}
                
                                     /> */}
                                    </div>
                                  </>
                                )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <StyledModal
              visible={isDuplicateEnrollmentModalVisible}
              footer={null}
              closable={false}
              maskClosable={false}
            >
              <div style={{ fontSize: 17, color: 'black', fontWeight: 600 }}>
                You’re Already Enrolled!
              </div>
              <div style={{ marginTop: 10 }}>
                Our records indicate that you’ve made a payment. Your Enrollment
                ID is {duplicateEnrollmentDetails.enrollemntId}. The receipt has
                been mailed to {duplicateEnrollmentDetails.email}. For any
                further query, please get in touch with your training advisor or
                email{' '}
                <a href="mailto:trainings@american-technology.net">
                  trainings@american-technology.net
                </a>
                .
              </div>
              <div style={{ textAlign: 'right' }}>
                <button
                  style={{ color: '#ff4552', fontWeight: 600 }}
                  onClick={() => setDuplicateEnrollmentModalVisible(false)}
                  className="button-unstyled"
                >
                  CLOSE
                </button>
              </div>
            </StyledModal>
          </section>
        </CheckoutContainer>
      )}
    </Layout>
  );
};

CheckoutPage.propTypes = {
  path: PropTypes.string.isRequired,
  trainingId: PropTypes.string,
};

export default CheckoutPage;
